import React, { useEffect, useState } from "react";
import { Card, message } from "antd";

import PoweredBy from "../../components/CommonUi/PoweredBy";
import TreatmentPlanTable from "./TreatmentPlanTable";
import TreatmentPlanFile from "./TreatmentPlanFile";
import DoctorNote from "./DoctorNote";

import { controller } from "../controller";
import "./style.css";

import loc from "../../assets/icons/location.svg";
import call from "../../assets/icons/call.svg";

const TreatmentPlan = (props) => {
  const [data, setData] = useState([]);
  const [isGettingTreatmentData, setisGettingTreatmentData] = useState(false);
  const [patientID, setPatientID] = useState(undefined);
  const [financingProviderLink, setFinancingProviderLink] = useState(undefined);
  const [currentOffice, setCurrentOffice] = useState(undefined);

  let patientId;
  // let currentOffice;

  const handleGetData = async () => {
    var url = window.location.href;
    const urlParams = new URLSearchParams(url.slice(url.indexOf("?")));
    // patientId = urlParams.get("patient_id") || localStorage.getItem("patient_id");
    patientId = urlParams.get("patient_id");

    if (patientId) {
      try {
        setisGettingTreatmentData(true);

        const response = await controller.getTreatmentPlan(patientId);
        const jsonData = await response.json; // Correctly parsing JSON from the response

        setPatientID(patientId);
        setData(jsonData);
        setCurrentOffice(jsonData);
        setFinancingProviderLink(jsonData[0].office.financing_provider_link);
      } catch (err) {
        console.error(err);
        message.error("Something went wrong while getting treatment data");
      } finally {
        setisGettingTreatmentData(false);
      }
    } else {
      // office = JSON.parse(localStorage.getItem("office_ids"));
      setCurrentOffice(JSON.parse(localStorage.getItem("officeLogo")));
    }
  };

  useEffect(() => {
    handleGetData();
  }, []);

  // Ensure data or props.preview is an array (default to empty array if not)
  // const treatmentData = Array.isArray(data) && data.length > 0 ? data : Array.isArray(props.preview) && props.preview.length > 0 ? props.preview : [];

  const treatmentData =
    props.preview &&
    Array.isArray(props.preview) &&
    props.preview.length > 0 &&
    props.preview[0].treatment_plans &&
    props.preview[0].treatment_plans.length > 0
      ? props.preview
      : Array.isArray(data) && data.length > 0
      ? data
      : [];

  const file = treatmentData[0] && treatmentData[0].image_files && treatmentData[0].image_files.length > 0 ? treatmentData[0] : props.image;

  if (isGettingTreatmentData) return null;

  return (
    <div style={{ background: "white", height: "100%" }}>
      {treatmentData.length > 0 && (
        <div className="preview-new-cards mb10">
          <div style={{ display: "flex", flexDirection: "row", alignItems: "center", marginLeft: "auto", marginBottom: 20 }} className="resp-logo">
            <img
              // src={
              //   currentOffice.logo
              //     ? currentOffice.logo
              //     : treatmentData[0] && treatmentData[0].office && treatmentData[0].office.office_logo
              //     ? treatmentData[0].office.office_logo
              //     : office[0] && office[0].logo && `http://api.smilepass.com${office[0].logo}`
              // }
              src={patientID ? data[0] && data[0].office.office_logo : currentOffice.logo}
              alt="office-profile"
              className="resp-size"
            />
          </div>
          <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>
            <div style={{ width: "100%" }}>
              {/* Office Name */}
              <p style={{ marginBottom: 5, fontSize: 24, fontWeight: 600 }}>{patientID ? data[0] && data[0].office.name : currentOffice.name}</p>

              {/* Office Address */}
              <div style={{ width: "100%", display: "flex", gap: 10 }} className="resp-div">
                <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: 5 }}>
                  <img src={loc} alt="" style={{ width: 20, height: 20 }} />
                  <p style={{ margin: 0, fontSize: 20 }}>{patientID ? data[0] && data[0].office.address : currentOffice.address}</p>
                </div>
              </div>

              {/* Office Phone */}
              <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: 5, marginBottom: 30 }}>
                <img src={call} alt="" style={{ width: 20, height: 20 }} />
                <p style={{ margin: 0, fontSize: 20 }}>{patientID ? data[0] && data[0].office.phone : currentOffice.phone}</p>
              </div>
            </div>
          </div>
          <p style={{ fontSize: 32, fontWeight: 600 }}>Treatment Plan</p>
          <p style={{ fontSize: 20, fontWeight: 400, marginBottom: 50 }}>
            Patient Name:{" "}
            {treatmentData[0] && treatmentData[0].patient && treatmentData[0].patient.first_name
              ? treatmentData[0].patient.first_name + " " + treatmentData[0].patient.last_name
              : treatmentData[0].first_name + " " + treatmentData[0].last_name}
          </p>
          <Card>
            <div style={{ paddingTop: "25px", paddingLeft: "10px" }}>
              <DoctorNote doctor_note={treatmentData[0] && treatmentData[0].note} />
            </div>

            <div style={{ padding: "25px 30px", border: "1px solid #F0F0F0", borderRadius: 8 }} className="resp-table">
              <p style={{ fontSize: 16, fontWeight: 600 }}>Recommended Treatments</p>
              <TreatmentPlanTable data={treatmentData} financingProviderLink={financingProviderLink} />
            </div>

            <div style={{ padding: "25px 5px" }}>
              <TreatmentPlanFile data={file} />
            </div>
          </Card>
        </div>
      )}
      <PoweredBy />
    </div>
  );
};

export default TreatmentPlan;
